<template>
  <div>
    <el-drawer
      class="drawer"
      style="overflow: auto"
      :visible.sync="gridData"
      :withHeader="false"
      :wrapperClosable="false"
      :lock-scroll="false"
      direction="rtl"
      size="1000"
    >
      <div
        style="
          width: 100%;
          float: left;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 0 50px;
        "
      >
        <div class="card_wrap">
          <div class="flex LR_center">
            <div class="LR_center">
              <div>
                <span> 当前国家： </span>
              </div>
              <!-- fba -->
              <div v-if="ShowType == 1">
                <el-select
                  v-model="fbaCountryid"
                  @change="getCountrycount"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in FBAcountry"
                    :key="item.id"
                    :label="item.namec"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- 小包 -->
              <div v-else>
                <el-select
                  v-model="smallCountryid"
                  @change="getCountrycount"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in smallcountry"
                    :key="item.id"
                    :label="item.countryName"
                    :value="item.countryCode"
                  >
                  </el-option>
                </el-select>
              </div>
              <div style="margin-left: 15px">
                <export-report :loading="exportLoading" @hideLoading="exportLoading = false" @showLoading="exportLoading = true">
                    <el-button :loading="exportLoading" type="primary">下载报价表</el-button>
                </export-report>
              </div>
            </div>
            <!-- <div style="margin-left: 30px">
              <span>当前业务： </span>
              <el-select
                v-model="ShowType"
                @change="changeType(ShowType)"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div>
              <el-button
                style="float: right"
                type="primary"
                round
                size="mini"
                icon="el-icon-close"
                @click="close()"
                >关闭
              </el-button>
            </div>
          </div>
          <!-- fba  table -->
          <el-table
            v-if="ShowType == 1"
            :data="lableCountry"
            border
            :header-cell-style="{ background: '#da6874', color: '#fff' }"
            style="width: 1100px"
          >
            <el-table-column
              prop="productName"
              align="center"
              label="产品名称"
              width="180"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="introduction"
              label="产品简介"
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p style="max-width: 500px">
                    产品简介: {{ scope.row.introduction }}
                  </p>
                  <div slot="reference" class="name-wrapper">
                    <div
                      v-show="scope.row.introduction"
                      size="medium"
                      style="
                        max-width: 200px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ scope.row.introduction }}
                    </div>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="aging" align="center" label="参考时效">
              <template slot-scope="scope">
                <span>{{ scope.row.aging }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              align="center"
              label="报价类型"
              width="180"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.isFba">
                  FBA报价
                </template>
                <template v-else>
                  私人地址报价
                </template>
              </template>
            </el-table-column>
            <el-table-column label="运费" align="center">
              <template slot-scope="scope">
                <price-blurring
                  :price-display-type="scope.row.priceDisplayType"
                  :currency="scope.row.currency"
                  :price="scope.row.priceinfo"
                />
              </template>
            </el-table-column>
            <el-table-column prop="address" label="报价链接" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="showText(scope.row, true, 2)"
                  type="text"
                  size="small"
                  >点击查价</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 小包  table -->
          <el-table
            v-if="ShowType == 2"
            :data="lableCountry"
            border
            :header-cell-style="{ background: '#da6874', color: '#fff' }"
            style="width: 1100px"
          >
            <el-table-column
              prop="productNameCn"
              align="center"
              label="产品名称"
              width="180"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="productkindIntroduction"
              label="产品简介"
            >
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p style="max-width: 500px">
                    产品简介: {{ scope.row.productkindIntroduction }}
                  </p>
                  <div slot="reference" class="name-wrapper">
                    <div
                      v-show="scope.row.productkindIntroduction"
                      size="medium"
                      style="
                        max-width: 200px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ scope.row.productkindIntroduction }}
                    </div>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="aging" align="center" label="参考时效">
              <template slot-scope="scope">
                <span>{{ scope.row.leastTimeliness }}-</span>
                <span>{{ scope.row.largestTimeliness }}工作日</span>
              </template>
            </el-table-column>
            <el-table-column label="运费" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.currency }}</span>
                <span
                  >{{ scope.row.lowestPrice }}/{{
                    scope.row.chargeType
                  }}<!--起--></span
                >
              </template>
            </el-table-column>
            <el-table-column prop="address" label="报价链接" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handleSmallInfo(scope.row)"
                  type="text"
                  size="small"
                  >点击查价</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
    <!-- 小包查价弹框 -->
    <el-dialog
      width="1200px"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
    >
      <small-get-item-bill
        v-if="showDialog"
        :objData="obj"
        :typeValue="2"
      ></small-get-item-bill>
    </el-dialog>
  </div>
</template>
<script>
import SmallGetItemBill from "./SmallGetItemBill.vue";
import PriceBlurring from "../../../../common/priceBlurring";
import {sortRecommendList} from "../../../../common/priceBlurring/utils";
import exportReport from '../../../../common/exportReport'
export default {
  components: {
    PriceBlurring,
    SmallGetItemBill,
    exportReport
  },
  props: {
    gridData: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
    labelData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ShowType: {
      type: Number,
      default: () => {
        return 1;
      },
    },
  },
  data() {
    return {
      exportLoading: false,
      obj: {},
      showDialog: false, // 小包查看数据
      FBAcountry: [],
      lableCountry: [],
      fbaCountryid: "",
      smallCountryid: "",
      typeId: null, //1 fba 2 小包
      typeList: [
        { name: "FBA", id: 1 },
        { name: "电商小包", id: 2 },
      ],
      endList: [],
      smallcountry: [],
      FbatransportCodes:["HY", "KY", "LY", "KH", "TY", "KT", "XB"],
    };
  },
  watch: {
    gridData:{
      immediate:true,
      handler(val) {
        if(!val) return false;
        console.log("gridData",JSON.parse(JSON.stringify(this.labelData)))
        if(this.FBAcountry.length) {
          this.init();
        }else {
          this.getCitydata()
            .then(this.init)
        }
        // this.getsmallCount();
      },
    },
    labelData: function (val) {
      console.log("labelData")
      // this.fbaCountryid = val.toCountryId;
      // this.smallCountryid = val.toCountryId
      // this.FbatransportCodes = ["HY", "KY", "LY", "KH", "TY", "KT", "XB"] //fba
      // this.getCountrycount();
    },
    // ShowType: function (val) {
    //   this.typeId = val;
    //   console.log('typeId？？？？: ', val);
    // },
  },
  computed: {},
  created() {

  },
  methods: {
    init(){
      let labelData = this.labelData||{};
      let countryId = labelData.toCountryId||"";
      console.log("init",countryId,labelData);
      this.fbaCountryid = countryId;
      this.smallCountryid = countryId;
      if(countryId) this.getCountrycount();
      else{
        this.lableCountry = [];
      }
    },
    // 获取小包查价信息
    handleSmallInfo(item) {
      console.log("handleSmallInfo", item);
      this.obj = {
        desCountryCode: item.destinationCountryCode, // 国家代码
        productId: item.id, // 产品Id
        start: item.departureCityNameCn,
        end: item.destinationCountryNameCn,
      };
      this.showDialog = true;
    },
    getsmallCount() {
      //获取小包 目的地
      this.axios
        .post("/ies/jiuyu/Countrylist")
        .then((res) => {
          console.log("end---", res);
          if (res.data.code == 200) {
            this.smallcountry = res.data.datas;
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {});
    },
    changeType(type) {
      console.log("this.typeId", this.ShowType);
      // if (this.typeId == 1) {
      //   this.typeId == 2
      //   this.fbaPricecount()
      //   //fba
      //   // this.endList = this.FBAcountry;
      // } else {
      //   this.typeId == 1
      //   //小包
      //   // this.endList = this.smallcountry;
      //   this.fbaCountryid = this.smallcountry[0].countryCode;
      //   this.getSmallpricecount();
      // }
      if (type == 1) {
        this.fbaCountryid = this.FBAcountry[0].id;
        this.fbaPricecount();
      } else {
        this.smallCountryid = this.smallcountry[0].countryCode;
        this.getSmallpricecount();
      }
    },
    getCountrycount() {
      console.log("change");
      //       根据国家查询报价
      if (this.ShowType == 1) {
        this.fbaPricecount();
      } else {
        this.getSmallpricecount();
      }
    },
    getSmallpricecount() {
      //查询小包专线报价
      let params = {
        countryCode: this.smallCountryid,
        lineTypeCode: "",
      };
      this.axios
        .post("/ies/jiuyu/getProductPriceByCountry", params)
        .then((res) => {
          console.log("data: ", res.data.datas);
          if (res.data.code == "200") {
            if (res.data.datas) {
              this.lableCountry = res.data.datas;
              this.gridData = true;
            } else {
              this.lableCountry = [];
            }
          } else {
            this.$message(res.data.message);
          }
        })
        .catch((res) => {});
    },
    showText(item, type, val) {
      console.log("ffffff");
      this.$parent.showText(item, type, val);
    },
    getCitydata() {
      console.log("this.FBAcountry");
      return this.axios
        .get(`/filedata/findAllCountryExcludeCN`)
        .then((res) => {
          this.FBAcountry = res.data.datas;
          console.log("this.FBAcountry: ", this.FBAcountry);
        })
        .catch((res) => {});
    },
    close() {
      this.ShowType = 1
      this.$parent.closeDrawer();
    },
    fbaPricecount() {
      this.checked1 = false;
      this.checked2 = false;
      let params = {};
      params = {
        fromCityId: this.labelData.fromCityid, //起运城市id,
        toCountryId: this.fbaCountryid, //目的地国家
        customerId: this.sessionGetUserInfo().customerid, //客户id
        goodstypeId: this.labelData.goodstypeId,
        transportCodes: this.FbatransportCodes,
      };
      this.axios
        .post("/FBAfee/queryFBAQuotedPriceInfoByCountry", params)
        .then((res) => {
          if (res.data.code == "200") {
            if (res.data.datas) {
              let list = res.data.datas||[];
              if(this.$store.getters.realNameState !== 3) sortRecommendList(list);
              this.lableCountry = list;
              // this.gridData = true;
            } else {
              this.lableCountry = [];
            }
          } else {
            this.$message(res.data.message);
          }
        })
        .catch((res) => {});
    },
  },

  mounted() {},
};
</script>
<style scoped>
.drawer >>> .el-drawer__body {
  overflow: auto !important;
}
.card_wrap {
  min-width: 1100px;
  width: 1100px;
  background: #ffffff;
  box-shadow: 0px 0px 39px 5px rgba(208, 208, 208, 0.32);
  border-radius: 10px;
  float: left;
  padding: 24px 35px 34px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.LR_center {
  align-items: center;
  margin-bottom: 10px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/Billdrawer.vue